import { useShopPageContainer } from "@tenant/hotels";
import type { PackageHotelShopPageProps } from "../types";
import { usePackageHotelShopNavigation } from "./shared";
import { usePackageHotelShopPageFetch } from "./usePackageHotelShopPageFetch";

export const usePackageHotelShopPage = (props: PackageHotelShopPageProps) => {
  usePackageHotelShopPageFetch(props);

  const { handlers } = usePackageHotelShopNavigation();

  return useShopPageContainer({ goToNextStep: handlers.onRoomSelection });
};
